import { memo } from 'react';

function Logo() {
  return (
    <svg
      width="150"
      height="32"
      className="logo"
      viewBox="0 0 150 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.5493 23.1666V8.64062H48.2209L54.0689 20.5106L59.9149 8.64062H62.5865V23.1666H60.0831V13.6006L55.3723 23.1666H52.7635L48.0527 13.6006V23.1666H45.5493Z"
        fill="var(--text-primary-color)"
      />
      <path
        d="M66.4338 21.7965C65.3959 20.7445 64.877 19.4725 64.877 17.9785C64.877 16.4845 65.3959 15.2125 66.4338 14.1605C67.4716 13.1085 68.7182 12.5825 70.1777 12.5825C71.6372 12.5825 72.9527 13.1085 74.0047 14.1605C75.0567 15.2125 75.5817 16.4845 75.5817 17.9785C75.5817 19.4725 75.0567 20.7445 74.0047 21.7965C72.9527 22.8485 71.6777 23.3745 70.1777 23.3745C68.6777 23.3745 67.4716 22.8485 66.4338 21.7965ZM67.3176 17.9785C67.3176 18.8365 67.5811 19.5485 68.1061 20.1165C68.6311 20.6845 69.3223 20.9665 70.1777 20.9665C71.0331 20.9665 71.779 20.6825 72.3324 20.1165C72.8858 19.5505 73.1635 18.8365 73.1635 17.9785C73.1635 17.1205 72.8858 16.3525 72.3324 15.7585C71.779 15.1645 71.0594 14.8665 70.1777 14.8665C69.2959 14.8665 68.6311 15.1645 68.1061 15.7585C67.5811 16.3525 67.3176 17.0945 67.3176 17.9785Z"
        fill="var(--text-primary-color)"
      />
      <path
        d="M77.7912 23.1665V12.7905H80.2946V14.3045C80.3371 14.2085 80.4203 14.0805 80.548 13.9205C80.6736 13.7625 80.8561 13.5705 81.0953 13.3505C81.3344 13.1285 81.6669 12.9465 82.0946 12.8005C82.5223 12.6545 82.9946 12.5825 83.5135 12.5825C84.6203 12.5825 85.5527 12.9325 86.3108 13.6305C87.0669 14.3285 87.4459 15.3765 87.4459 16.7745V23.1665H84.9426V17.5425C84.9426 15.7585 84.2128 14.8665 82.7554 14.8665C81.9 14.8665 81.2757 15.1165 80.8844 15.6145C80.4932 16.1125 80.2966 16.6865 80.2966 17.3365V23.1685H77.7932L77.7912 23.1665Z"
        fill="var(--text-primary-color)"
      />
      <path
        d="M91.1047 21.7965C90.0669 20.7445 89.548 19.4725 89.548 17.9785C89.548 16.4845 90.0669 15.2125 91.1047 14.1605C92.1426 13.1085 93.3892 12.5825 94.8487 12.5825C96.3081 12.5825 97.4818 13.0905 98.4973 14.1085C99.5128 15.1245 100.042 16.3605 100.084 17.8125C100.084 18.0625 100.076 18.2485 100.064 18.3725H91.9662C92.0351 19.1745 92.3331 19.8285 92.8601 20.3345C93.3851 20.8405 94.048 21.0925 94.8487 21.0925C95.4223 21.0925 95.9311 20.9685 96.373 20.7185C96.8149 20.4685 97.127 20.1165 97.3095 19.6605L99.6649 20.1385C99.3142 21.1065 98.698 21.8885 97.8142 22.4825C96.9304 23.0765 95.9433 23.3745 94.8487 23.3745C93.3892 23.3745 92.1426 22.8485 91.1047 21.7965ZM92.0919 16.8805H97.5385C97.3561 16.2305 97.0257 15.7105 96.5493 15.3245C96.073 14.9365 95.5054 14.7425 94.8466 14.7425C94.1878 14.7425 93.5737 14.9365 93.0912 15.3245C92.6088 15.7125 92.2743 16.2305 92.0919 16.8805Z"
        fill="var(--text-primary-color)"
      />
      <path
        d="M101.599 15.2407V12.7927H102.861V9.88672H105.365V12.7927H108.057V15.2407H105.365V19.4327C105.365 19.8207 105.48 20.1307 105.711 20.3667C105.943 20.6027 106.255 20.7187 106.648 20.7187H108.057V23.1667H105.47C104.684 23.1667 104.053 22.8967 103.577 22.3567C103.101 21.8167 102.861 21.0987 102.861 20.1987V15.2387H101.599V15.2407Z"
        fill="var(--text-primary-color)"
      />
      <path
        d="M109.423 20.4065C109.366 19.5625 109.62 18.8065 110.181 18.1345C110.743 17.4645 111.519 17.0865 112.516 17.0045L116.702 16.6305V16.4645C116.674 16.0625 116.485 15.7425 116.134 15.4985C115.784 15.2565 115.423 15.1045 115.05 15.0425C114.679 14.9805 114.276 14.9485 113.842 14.9485C112.51 14.9485 111.444 15.1625 110.645 15.5925L109.993 13.6625C111.227 12.9425 112.656 12.5845 114.284 12.5845C115.911 12.5845 117.071 12.9365 117.932 13.6425C118.796 14.3485 119.226 15.4345 119.226 16.9005V23.1665H116.745V21.8585C115.581 22.8685 114.312 23.3725 112.938 23.3725C111.985 23.3725 111.174 23.0825 110.509 22.5005C109.845 21.9185 109.482 21.2205 109.427 20.4045L109.423 20.4065ZM111.778 20.0345C111.778 20.3945 111.926 20.6985 112.22 20.9465C112.514 21.1945 112.913 21.3205 113.418 21.3205C114.188 21.3345 114.904 21.1265 115.563 20.6985C116.222 20.2705 116.615 19.8765 116.741 19.5165V18.3325L113.459 18.7265C112.897 18.8085 112.478 18.9685 112.198 19.2025C111.918 19.4385 111.776 19.7145 111.776 20.0325L111.778 20.0345Z"
        fill="var(--text-primary-color)"
      />
      <path
        d="M121.916 21.8187C121.916 21.3907 122.074 21.0187 122.388 20.7087C122.702 20.3987 123.077 20.2427 123.513 20.2427C123.949 20.2427 124.322 20.3987 124.638 20.7087C124.954 21.0187 125.11 21.3907 125.11 21.8187C125.11 22.2467 124.956 22.6387 124.648 22.9487C124.34 23.2587 123.961 23.4147 123.513 23.4147C123.065 23.4147 122.686 23.2587 122.378 22.9487C122.07 22.6367 121.916 22.2607 121.916 21.8187Z"
        fill="var(--text-primary-color)"
      />
      <path
        d="M127.214 20.4065C127.157 19.5625 127.411 18.8065 127.972 18.1345C128.534 17.4645 129.31 17.0865 130.307 17.0045L134.493 16.6305V16.4645C134.465 16.0625 134.276 15.7425 133.926 15.4985C133.575 15.2565 133.214 15.1045 132.841 15.0425C132.47 14.9805 132.067 14.9485 131.633 14.9485C130.301 14.9485 129.235 15.1625 128.436 15.5925L127.784 13.6625C129.018 12.9425 130.447 12.5845 132.075 12.5845C133.703 12.5845 134.862 12.9365 135.724 13.6425C136.587 14.3485 137.017 15.4345 137.017 16.9005V23.1665H134.536V21.8585C133.372 22.8685 132.103 23.3725 130.729 23.3725C129.776 23.3725 128.966 23.0825 128.301 22.5005C127.636 21.9185 127.273 21.2205 127.218 20.4045L127.214 20.4065ZM129.57 20.0345C129.57 20.3945 129.718 20.6985 130.011 20.9465C130.305 21.1945 130.705 21.3205 131.209 21.3205C131.98 21.3345 132.695 21.1265 133.354 20.6985C134.013 20.2705 134.406 19.8765 134.532 19.5165V18.3325L131.25 18.7265C130.688 18.8085 130.269 18.9685 129.989 19.2025C129.709 19.4385 129.568 19.7145 129.568 20.0325L129.57 20.0345Z"
        fill="var(--text-primary-color)"
      />
      <path
        d="M144.124 12.5846C144.811 12.5846 145.437 12.7306 146.007 13.0206C146.574 13.3106 147.006 13.6986 147.3 14.1826V8.64258H149.781V23.1686H147.3V21.7786C147.006 22.2626 146.574 22.6506 146.007 22.9406C145.439 23.2306 144.811 23.3766 144.124 23.3766C142.735 23.3766 141.553 22.8466 140.58 21.7886C139.605 20.7306 139.119 19.4606 139.119 17.9806C139.119 16.5006 139.605 15.2146 140.58 14.1626C141.555 13.1106 142.735 12.5846 144.124 12.5846ZM144.503 20.9266C145.33 20.9266 146.003 20.6706 146.522 20.1586C147.041 19.6466 147.3 18.9206 147.3 17.9806C147.3 17.0406 147.041 16.2586 146.522 15.7186C146.003 15.1786 145.33 14.9086 144.503 14.9086C143.676 14.9086 142.95 15.2026 142.411 15.7906C141.872 16.3786 141.602 17.1086 141.602 17.9806C141.602 18.8526 141.872 19.5266 142.411 20.0866C142.95 20.6466 143.647 20.9266 144.503 20.9266Z"
        fill="var(--text-primary-color)"
      />
      <path
        d="M0 23.1905C0 26.1825 2.45878 28.6065 5.48919 28.6065C8.12635 28.6065 10.3277 26.7705 10.8568 24.3245L4.33986 17.8945C1.86081 18.4165 0 20.5885 0 23.1905Z"
        fill="url(#paint0_linear_2887_24340)"
      />
      <path
        d="M10.8568 24.3226C10.3257 26.7746 8.12432 28.6066 5.48716 28.6066C2.45473 28.6066 0 26.1826 0 23.1926C0 23.1706 0 23.1426 0.00608108 23.1206C0.0972973 26.0346 2.51351 28.3626 5.48919 28.3626C8.05743 28.3626 10.2101 26.6246 10.8081 24.2746L10.8588 24.3246L10.8568 24.3226Z"
        fill="#FFECB8"
      />
      <path
        d="M25.9439 18.9965C25.8933 19.3705 25.723 19.7265 25.4311 20.0165L17.2662 28.0765C16.5426 28.7845 15.3811 28.7845 14.6574 28.0765L8.93311 22.4225L0.756086 14.3625C0.0385189 13.6485 0.0385189 12.5025 0.756086 11.7885L3.1946 9.38845L8.92703 3.73245C9.30406 3.36045 9.80676 3.18245 10.3095 3.20445C10.7493 3.22645 11.1912 3.40445 11.5297 3.73445L25.4311 17.4505C25.8608 17.8745 26.0291 18.4485 25.9439 18.9985V18.9965Z"
        fill="url(#paint1_linear_2887_24340)"
      />
      <path
        d="M25.9439 18.9966C25.8264 18.6346 25.6155 18.3006 25.3237 18.0166L10.3095 3.20459C10.7493 3.22659 11.1912 3.40459 11.5297 3.73459L25.4311 17.4506C25.8608 17.8746 26.0291 18.4486 25.9439 18.9986V18.9966Z"
        fill="#89C632"
      />
      <path
        d="M15.5534 28.5627C15.225 28.4907 14.9149 28.3287 14.6615 28.0787L0.76013 14.3627C0.222968 13.8327 0.0831032 13.0587 0.348644 12.4067C0.275671 13.0367 0.484455 13.6927 0.974995 14.1787L10.6966 23.7707L15.5513 28.5607L15.5534 28.5627Z"
        fill="#BBE87C"
      />
      <path
        d="M39.4905 17.4487L25.5892 3.7327C24.8696 3.0227 23.704 3.0227 22.9845 3.7327L17.2561 9.3847L25.429 17.4487C26.1486 18.1587 26.1486 19.3087 25.429 20.0187L22.9926 22.4227L28.7209 28.0747C29.4405 28.7847 30.6061 28.7847 31.3257 28.0747L39.4905 20.0187C40.2101 19.3087 40.2101 18.1587 39.4905 17.4487Z"
        fill="url(#paint2_linear_2887_24340)"
      />
      <path
        d="M29.6128 28.5627C29.2845 28.4907 28.9743 28.3287 28.7209 28.0787L14.8216 14.3627C14.2845 13.8327 14.1446 13.0587 14.4101 12.4067C14.3372 13.0367 14.5459 13.6927 15.0365 14.1787L24.7581 23.7707L29.6128 28.5607V28.5627Z"
        fill="#91CFF9"
      />
      <path
        d="M25.429 17.4488L17.2561 9.38477L14.8196 11.7888C14.1 12.4988 14.1 13.6488 14.8196 14.3588L22.9926 22.4228L25.429 20.0188C26.1486 19.3088 26.1486 18.1588 25.429 17.4488Z"
        fill="url(#paint3_linear_2887_24340)"
      />
      <path
        d="M23.1973 22.2268L22.9946 22.4208L14.8257 14.3608C14.2885 13.8308 14.1487 13.0568 14.4142 12.4048C14.3412 13.0348 14.55 13.6908 15.0405 14.1768L23.1993 22.2268H23.1973Z"
        fill="#2EC4FF"
      />
      <path
        d="M5.48918 17.7749C5.09391 17.7749 4.7108 17.8169 4.33986 17.8949L10.8568 24.3249C10.9358 23.9589 10.9784 23.5809 10.9784 23.1909C10.9784 20.1989 8.52162 17.7749 5.48918 17.7749Z"
        fill="#B3E50A"
      />
      <path
        d="M39.9993 18.9947C39.8818 18.6327 39.671 18.2987 39.3791 18.0147L24.3649 3.20068C24.8047 3.22268 25.2466 3.40068 25.5851 3.73068L39.4865 17.4467C39.9162 17.8707 40.0845 18.4447 39.9993 18.9947Z"
        fill="#3486E8"
      />
      <path
        d="M10.9196 23.9889C10.9034 24.1009 10.8811 24.2109 10.8568 24.3229L10.8061 24.2729L4.34189 17.8949C4.4554 17.8729 4.56689 17.8509 4.68648 17.8389L10.9196 23.9889Z"
        fill="#B3CC21"
      />
      <path
        d="M25.9683 18.7167C25.9683 18.8107 25.9561 18.9067 25.946 18.9947C25.8284 18.6327 25.6176 18.2987 25.3257 18.0147L16.9196 9.72072L17.2581 9.38672L25.427 17.4467H25.4331C25.5243 17.5367 25.6034 17.6307 25.6642 17.7307C25.7311 17.8247 25.7878 17.9307 25.8345 18.0427V18.0487C25.8791 18.1547 25.9135 18.2607 25.9358 18.3727V18.3847C25.9581 18.4967 25.9703 18.6067 25.9703 18.7187L25.9683 18.7167Z"
        fill="#36C0EA"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2887_24340"
          x1="3.82905"
          y1="25.3625"
          x2="7.41949"
          y2="20.5382"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB800" />
          <stop offset="0.89" stopColor="#FFD878" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2887_24340"
          x1="20.5541"
          y1="24.2825"
          x2="5.63917"
          y2="7.07791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#74D400" />
          <stop offset="0.52" stopColor="#A1FA14" />
          <stop offset="1" stopColor="#B7FB0A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2887_24340"
          x1="35.1892"
          y1="23.7647"
          x2="20.7928"
          y2="9.29745"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D96E6" />
          <stop offset="0.91" stopColor="#33A8F7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2887_24340"
          x1="30.0203"
          y1="26.0428"
          x2="15.7547"
          y2="11.0314"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.13" stopColor="#2D96E6" />
          <stop offset="0.15" stopColor="#2E97E6" />
          <stop offset="0.59" stopColor="#4DC6F8" />
          <stop offset="0.81" stopColor="#5AD8FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default memo(Logo);
